import { AxiosError, AxiosRequestConfig } from 'axios';
import {
  IAddIncidentLogBody,
  IAddIncidentLogResponse,
  ICloseIncidentsBody,
  ICloseIncidentsResponse,
  ICreateIncidentBody,
  ICreateIncidentResponse,
  IIncidentHistoryEvent,
  IIncidentReasonsGroupedByType,
  IIncidentsByTypeGroup,
  INCIDENT_SOURCE_REFERENCE_ID,
  INCIDENT_TYPE_ID
} from '../types/incidents.types';
import { apiGet, apiPost, apiPut } from './api';

const { REACT_APP_SUBSCRIPTION } = process.env;

const getIncidentReasonsGrouped = async () => {
  return apiGet<AxiosRequestConfig, IIncidentReasonsGroupedByType[]>(
    `${REACT_APP_SUBSCRIPTION}/incident/reasons/grouped`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const createServiceIncident = async (body: ICreateIncidentBody) => {
  return apiPost<AxiosRequestConfig, ICreateIncidentBody, ICreateIncidentResponse>(
    `${REACT_APP_SUBSCRIPTION}/incident`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getOpenIncidents = async (
  sourceId: number,
  incidentTypeIds?: INCIDENT_TYPE_ID[],
  referenceId: INCIDENT_SOURCE_REFERENCE_ID = INCIDENT_SOURCE_REFERENCE_ID.LOGISTIC_SERVICE
) => {
  const baseUrl = `${REACT_APP_SUBSCRIPTION}/incident?sourceId=${sourceId}&referenceId=${referenceId}`;
  const hasTypes = incidentTypeIds != null && incidentTypeIds.length > 0;
  const url = hasTypes ? `${baseUrl}&incidentTypeIds=${incidentTypeIds.join(',')}` : baseUrl;
  return apiGet<AxiosRequestConfig, IIncidentsByTypeGroup[]>(url)
    .then(groups => Promise.resolve(groups.flatMap(group => group.incidents)))
    .catch((error: AxiosError) => Promise.reject(error));
};

const closeIncidentsBulk = async (body: ICloseIncidentsBody) => {
  return apiPut<AxiosRequestConfig, ICloseIncidentsBody, ICloseIncidentsResponse>(
    `${REACT_APP_SUBSCRIPTION}/incident/close`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const addIncidentLog = async (incidentId: number, body: IAddIncidentLogBody) => {
  return apiPut<AxiosRequestConfig, IAddIncidentLogBody, IAddIncidentLogResponse>(
    `${REACT_APP_SUBSCRIPTION}/incident/${incidentId}/log`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Obtiene los eventos de apertura y cierre de incidentes de un servicio logístico
 * para mostrarlos en el historial del Tab4History.
 */
const getIncidentsHistory = async (
  logisticServiceId: number,
  referenceId: INCIDENT_SOURCE_REFERENCE_ID = INCIDENT_SOURCE_REFERENCE_ID.LOGISTIC_SERVICE
) => {
  return apiGet<AxiosRequestConfig, IIncidentHistoryEvent[]>(
    `${REACT_APP_SUBSCRIPTION}/incident/history/${logisticServiceId}?referenceId=${referenceId}`
  )
    .then(response => Promise.resolve(response ?? []))
    .catch((error: AxiosError) => Promise.reject(error));
};

export {
  getIncidentReasonsGrouped,
  createServiceIncident,
  getOpenIncidents,
  closeIncidentsBulk,
  addIncidentLog,
  getIncidentsHistory
};
